const printOrder = { aui: 'aui', iau: 'iau', iua: 'iua' };
export default printOrder;
